import React from 'react';

import { responsiveStyle } from '../../util/helpers';
import { windowBreakpoints } from '../../hooks/useDeviceSize';
import { AliasToken } from 'antd/es/theme/internal';

export const headerStyle = (globalStyle: AliasToken, viewportSize: windowBreakpoints, isActive?: boolean) =>
  responsiveStyle(viewportSize, {
    container: {
      backgroundColor: globalStyle.colorPrimary,
      borderBottom: '1px solid black',
      display: 'flex',
      zIndex: 1000,
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 32px',
      marginBottom: '0px',
      top: 0,
      '!desktop': {
        padding: '0 16px',
      },
    },
    logoWrapper: {
      userSelect: 'all',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    logo: {
      height: 'auto',
      width: '156px',
      userSelect: 'none',
      pointerEvents: 'none',
    },
    menuIcon: {
      color: globalStyle.colorTextSecondary,
      fontSize: '20px',
      transition: `transform ease-in-out ${globalStyle.motionDurationMid}`,
      '!desktop': {
        transform: `rotate(${isActive ? 90 + 90 + 90 : '0'}deg)`,
      },
    },
    iconButton: {
      width: '36px',
      height: '36px',
      borderRadius: '50%',
      color: globalStyle.colorWhite,
    },
    flexer: {
      width: '100%',
    },
    text: {
      color: globalStyle.colorTextSecondary,
    },
  });

export default headerStyle;
